import React, { ReactNode, useState } from "react";
import styles from '../Link/link.module.scss';
import { useNavigate } from "react-router-dom";

interface LinkProps {
    href: string;
    isLink?: boolean;
    onlyShow?: boolean;
    title: string;
    icon: ReactNode;
    image?: string;
    backgroundColor: string;
    backgroundColorHover: string;
    colorText: string;
    maxWSpan?: boolean;
}

const Link: React.FC<LinkProps> = ({
    href,
    onlyShow = false,
    title,
    icon,
    image = null,
    backgroundColor,
    backgroundColorHover,
    colorText,
    maxWSpan = false,
    isLink = false,
}) => {
    const navigate = useNavigate();
    const [bgColor, setBgColor] = useState(backgroundColor);

    return (
        onlyShow ?
            <div
                style={{
                    background: bgColor,
                    transition: "background 0.5s ease",
                    display: "block",
                    padding: "10px 20px",
                    margin: "10px 0",
                    textDecoration: "none",
                    color: "black",
                    borderRadius: "8px"
                }}
                onMouseEnter={() => setBgColor(backgroundColorHover)}
                onMouseLeave={() => setBgColor(backgroundColor)}
            >
                {image ? (
                    <div className={`${styles["h-40px"]} d-flex align-items-center justify-content-between`}>
                        <div className={styles["min-w-img"]}>
                            <img
                                src={image}
                                alt={title}
                                className={styles["link-image"]}
                            />
                        </div>
                        <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                            <span style={{ color: colorText }}>{title}</span>
                        </div>
                        <div className={styles["link-image"]}>
                        </div>
                    </div>
                ) : (
                    <div className={`${styles["h-40px"]} d-flex align-items-center justify-content-center`}>
                        <div className={styles["min-w-img"]}>
                            {icon}
                        </div>
                        <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                            <span style={{ color: colorText }}>{title}</span>
                        </div>
                        {maxWSpan &&
                            <div style={{ width: "25px" }}>
                            </div>
                        }
                    </div>
                )}
            </div>
            :
            isLink ?
                <div
                    style={{
                        background: bgColor,
                        transition: "background 0.5s ease",
                        display: "block",
                        padding: "10px 20px",
                        margin: "10px 0",
                        textDecoration: "none",
                        color: "black",
                        borderRadius: "8px"
                    }}
                    onClick={() => navigate(href)}
                    onMouseEnter={() => setBgColor(backgroundColorHover)}
                    onMouseLeave={() => setBgColor(backgroundColor)}
                >
                    {image ? (
                        <div className={`${styles["h-40px"]} d-flex align-items-center justify-content-between`}>
                            <div className={styles["min-w-img"]}>
                                <img
                                    src={image}
                                    alt={title}
                                    className={styles["link-image"]}
                                />
                            </div>
                            <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                                <span style={{ color: colorText }}>{title}</span>
                            </div>
                            <div className={styles["link-image"]}>
                            </div>
                        </div>
                    ) : (
                        <div className={`${styles["h-40px"]} d-flex align-items-center justify-content-center`}>
                            <div className={styles["min-w-img"]}>
                                {icon}
                            </div>
                            <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                                <span style={{ color: colorText }}>{title}</span>
                            </div>
                            {maxWSpan &&
                                <div style={{ width: "25px" }}>
                                </div>
                            }
                        </div>
                    )}
                </div>
                :
                <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    style={{ background: bgColor, transition: "background 0.5s ease" }}
                    onMouseEnter={() => setBgColor(backgroundColorHover)}
                    onMouseLeave={() => setBgColor(backgroundColor)}
                >
                    {image ? (
                        <div className={`${styles["h-40px"]} d-flex align-items-center justify-content-between`}>
                            <div className={styles["min-w-img"]}>
                                <img
                                    src={image}
                                    alt={title}
                                    className={styles["link-image"]}
                                />
                            </div>
                            <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                                <span style={{ color: colorText }}>{title}</span>
                            </div>
                            <div className={styles["link-image"]}>
                            </div>
                        </div>
                    ) : (
                        <div className={`${styles["h-40px"]} d-flex align-items-center justify-content-center`}>
                            <div className={styles["min-w-img"]}>
                                {icon}
                            </div>
                            <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                                <span style={{ color: colorText }}>{title}</span>
                            </div>
                            {maxWSpan &&
                                <div style={{ width: "25px" }}>
                                </div>
                            }
                        </div>
                    )}

                </a>
    );
};

export default Link;
